// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message.
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import {
  Count,
  CountFromJSON,
  CountToJSON,
  DefaultResponseError,
  DefaultResponseErrorFromJSON,
  DefaultResponseErrorToJSON,
  ForbiddenError,
  ForbiddenErrorFromJSON,
  ForbiddenErrorToJSON,
  QacConversationFeedback,
  QacConversationFeedbackFromJSON,
  QacConversationFeedbackToJSON,
  QacConversationFeedbackPayload,
  QacConversationFeedbackPayloadFromJSON,
  QacConversationFeedbackPayloadToJSON,
  QacConversationMessage,
  QacConversationMessageFromJSON,
  QacConversationMessageToJSON,
  QacConversationMessagePayload,
  QacConversationMessagePayloadFromJSON,
  QacConversationMessagePayloadToJSON,
  QacConversationThread,
  QacConversationThreadFromJSON,
  QacConversationThreadToJSON,
  QacConversationThreadPayload,
  QacConversationThreadPayloadFromJSON,
  QacConversationThreadPayloadToJSON,
  QacConversationThreadWithMessages,
  QacConversationThreadWithMessagesFromJSON,
  QacConversationThreadWithMessagesToJSON,
  TrainingArtifact,
  TrainingArtifactFromJSON,
  TrainingArtifactToJSON,
  TrainingArtifactPayload,
  TrainingArtifactPayloadFromJSON,
  TrainingArtifactPayloadToJSON,
  TrainingSession,
  TrainingSessionFromJSON,
  TrainingSessionToJSON,
  TrainingSessionPayload,
  TrainingSessionPayloadFromJSON,
  TrainingSessionPayloadToJSON,
  TrainingSessionToken,
  TrainingSessionTokenFromJSON,
  TrainingSessionTokenToJSON,
} from "../models";

export interface AddQaCopilotFeedbackRequest {
  id: number;
  qacConversationFeedbackPayload?: QacConversationFeedbackPayload;
}

export interface CountTrainingArtifactsRequest {
  trainingSession?: number;
  status?: CountTrainingArtifactsStatusEnum;
  filter?: string;
}

export interface CountTrainingSessionsRequest {
  testcase?: number;
  testcaserevision?: number;
  status?: CountTrainingSessionsStatusEnum;
  result?: CountTrainingSessionsResultEnum;
  filter?: string;
}

export interface CreateQaCopilotMessageRequest {
  id: number;
  qacConversationMessagePayload?: QacConversationMessagePayload;
}

export interface CreateQaCopilotThreadRequest {
  qacConversationThreadPayload?: QacConversationThreadPayload;
}

export interface CreateTrainingArtifactRequest {
  trainingArtifactPayload: TrainingArtifactPayload;
}

export interface CreateTrainingSessionRequest {
  trainingSessionPayload: TrainingSessionPayload;
}

export interface GetQaCopilotThreadRequest {
  id: number;
}

export interface GetTrainingArtifactRequest {
  id: number;
}

export interface GetTrainingSessionRequest {
  id: number;
}

export interface GetTrainingSessionTokenRequest {
  id: number;
}

export interface ListQaCopilotMessagesRequest {
  id: number;
  limit?: number;
  start?: number;
  sort?: string;
}

export interface ListQaCopilotThreadsRequest {
  company: number;
  project?: number;
  status?: ListQaCopilotThreadsStatusEnum;
  sourceUrl?: string;
  search?: string;
  limit?: number;
  start?: number;
  sort?: string;
}

export interface ListTrainingArtifactsRequest {
  trainingSession?: number;
  status?: ListTrainingArtifactsStatusEnum;
  stepIndex?: number;
  limit?: number;
  start?: number;
  sort?: string;
  filter?: string;
}

export interface ListTrainingSessionsRequest {
  testcase?: number;
  testcaserevision?: number;
  status?: ListTrainingSessionsStatusEnum;
  result?: ListTrainingSessionsResultEnum;
  limit?: number;
  start?: number;
  sort?: string;
  filter?: string;
}

export interface UpdateTrainingArtifactRequest {
  trainingArtifactPayload: TrainingArtifactPayload;
  id: number;
}

export interface UpdateTrainingSessionRequest {
  trainingSessionPayload: TrainingSessionPayload;
  id: number;
}

/**
 * no description
 */
export class QaCopilotApi extends runtime.BaseAPI {
  /**
   * File uploads for feedback should use the upload path. Pass resulting upload IDs if/when attachments are added to feedback payloads in future.
   * Add feedback to a QA Copilot message
   */
  async addQaCopilotFeedbackRaw(
    requestParameters: AddQaCopilotFeedbackRequest
  ): Promise<runtime.ApiResponse<QacConversationFeedback>> {
    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        "id",
        "Required parameter requestParameters.id was null or undefined when calling addQaCopilotFeedback."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/qa_copilot/messages/{id}/feedback`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(requestParameters.id))
      ),
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: QacConversationFeedbackPayloadToJSON(
        requestParameters.qacConversationFeedbackPayload
      ),
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      QacConversationFeedbackFromJSON(jsonValue)
    );
  }

  /**
   * File uploads for feedback should use the upload path. Pass resulting upload IDs if/when attachments are added to feedback payloads in future.
   * Add feedback to a QA Copilot message
   */
  async addQaCopilotFeedback(
    requestParameters: AddQaCopilotFeedbackRequest
  ): Promise<QacConversationFeedback> {
    const response = await this.addQaCopilotFeedbackRaw(requestParameters);
    return await response.value();
  }

  /**
   * Returns the number of QA Copilot artifacts that match provided filters
   * Count training artifacts
   */
  async countTrainingArtifactsRaw(
    requestParameters: CountTrainingArtifactsRequest
  ): Promise<runtime.ApiResponse<Count>> {
    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.trainingSession !== undefined) {
      queryParameters["training_session"] = requestParameters.trainingSession;
    }

    if (requestParameters.status !== undefined) {
      queryParameters["status"] = requestParameters.status;
    }

    if (requestParameters.filter !== undefined) {
      queryParameters["_filter"] = requestParameters.filter;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/trainingartifacts/count`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CountFromJSON(jsonValue)
    );
  }

  /**
   * Returns the number of QA Copilot artifacts that match provided filters
   * Count training artifacts
   */
  async countTrainingArtifacts(
    requestParameters: CountTrainingArtifactsRequest
  ): Promise<Count> {
    const response = await this.countTrainingArtifactsRaw(requestParameters);
    return await response.value();
  }

  /**
   * Returns the count of QA Copilot training sessions that match provided filters
   * Count training sessions
   */
  async countTrainingSessionsRaw(
    requestParameters: CountTrainingSessionsRequest
  ): Promise<runtime.ApiResponse<Count>> {
    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.testcase !== undefined) {
      queryParameters["testcase"] = requestParameters.testcase;
    }

    if (requestParameters.testcaserevision !== undefined) {
      queryParameters["testcaserevision"] = requestParameters.testcaserevision;
    }

    if (requestParameters.status !== undefined) {
      queryParameters["status"] = requestParameters.status;
    }

    if (requestParameters.result !== undefined) {
      queryParameters["result"] = requestParameters.result;
    }

    if (requestParameters.filter !== undefined) {
      queryParameters["_filter"] = requestParameters.filter;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/trainingsessions/count`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CountFromJSON(jsonValue)
    );
  }

  /**
   * Returns the count of QA Copilot training sessions that match provided filters
   * Count training sessions
   */
  async countTrainingSessions(
    requestParameters: CountTrainingSessionsRequest
  ): Promise<Count> {
    const response = await this.countTrainingSessionsRaw(requestParameters);
    return await response.value();
  }

  /**
   * File uploads are handled via the upload path (`./spec/paths/upload.yaml`). Include upload IDs in the `attachments` array.
   * Create a message in a QA Copilot thread
   */
  async createQaCopilotMessageRaw(
    requestParameters: CreateQaCopilotMessageRequest
  ): Promise<runtime.ApiResponse<QacConversationMessage>> {
    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        "id",
        "Required parameter requestParameters.id was null or undefined when calling createQaCopilotMessage."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/qa_copilot/threads/{id}/messages`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(requestParameters.id))
      ),
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: QacConversationMessagePayloadToJSON(
        requestParameters.qacConversationMessagePayload
      ),
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      QacConversationMessageFromJSON(jsonValue)
    );
  }

  /**
   * File uploads are handled via the upload path (`./spec/paths/upload.yaml`). Include upload IDs in the `attachments` array.
   * Create a message in a QA Copilot thread
   */
  async createQaCopilotMessage(
    requestParameters: CreateQaCopilotMessageRequest
  ): Promise<QacConversationMessage> {
    const response = await this.createQaCopilotMessageRaw(requestParameters);
    return await response.value();
  }

  /**
   * Create a QA Copilot conversation thread
   */
  async createQaCopilotThreadRaw(
    requestParameters: CreateQaCopilotThreadRequest
  ): Promise<runtime.ApiResponse<QacConversationThread>> {
    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/qa_copilot/threads`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: QacConversationThreadPayloadToJSON(
        requestParameters.qacConversationThreadPayload
      ),
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      QacConversationThreadFromJSON(jsonValue)
    );
  }

  /**
   * Create a QA Copilot conversation thread
   */
  async createQaCopilotThread(
    requestParameters: CreateQaCopilotThreadRequest
  ): Promise<QacConversationThread> {
    const response = await this.createQaCopilotThreadRaw(requestParameters);
    return await response.value();
  }

  /**
   * Persists a single QA Copilot artifact entry
   * Create training artifact
   */
  async createTrainingArtifactRaw(
    requestParameters: CreateTrainingArtifactRequest
  ): Promise<runtime.ApiResponse<TrainingArtifact>> {
    if (
      requestParameters.trainingArtifactPayload === null ||
      requestParameters.trainingArtifactPayload === undefined
    ) {
      throw new runtime.RequiredError(
        "trainingArtifactPayload",
        "Required parameter requestParameters.trainingArtifactPayload was null or undefined when calling createTrainingArtifact."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/trainingartifacts`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: TrainingArtifactPayloadToJSON(
        requestParameters.trainingArtifactPayload
      ),
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      TrainingArtifactFromJSON(jsonValue)
    );
  }

  /**
   * Persists a single QA Copilot artifact entry
   * Create training artifact
   */
  async createTrainingArtifact(
    requestParameters: CreateTrainingArtifactRequest
  ): Promise<TrainingArtifact> {
    const response = await this.createTrainingArtifactRaw(requestParameters);
    return await response.value();
  }

  /**
   * Persists metadata for a QA Copilot training run
   * Create training session
   */
  async createTrainingSessionRaw(
    requestParameters: CreateTrainingSessionRequest
  ): Promise<runtime.ApiResponse<TrainingSession>> {
    if (
      requestParameters.trainingSessionPayload === null ||
      requestParameters.trainingSessionPayload === undefined
    ) {
      throw new runtime.RequiredError(
        "trainingSessionPayload",
        "Required parameter requestParameters.trainingSessionPayload was null or undefined when calling createTrainingSession."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/trainingsessions`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: TrainingSessionPayloadToJSON(
        requestParameters.trainingSessionPayload
      ),
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      TrainingSessionFromJSON(jsonValue)
    );
  }

  /**
   * Persists metadata for a QA Copilot training run
   * Create training session
   */
  async createTrainingSession(
    requestParameters: CreateTrainingSessionRequest
  ): Promise<TrainingSession> {
    const response = await this.createTrainingSessionRaw(requestParameters);
    return await response.value();
  }

  /**
   * Get a QA Copilot conversation thread
   */
  async getQaCopilotThreadRaw(
    requestParameters: GetQaCopilotThreadRequest
  ): Promise<runtime.ApiResponse<QacConversationThreadWithMessages>> {
    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        "id",
        "Required parameter requestParameters.id was null or undefined when calling getQaCopilotThread."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/qa_copilot/threads/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(requestParameters.id))
      ),
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      QacConversationThreadWithMessagesFromJSON(jsonValue)
    );
  }

  /**
   * Get a QA Copilot conversation thread
   */
  async getQaCopilotThread(
    requestParameters: GetQaCopilotThreadRequest
  ): Promise<QacConversationThreadWithMessages> {
    const response = await this.getQaCopilotThreadRaw(requestParameters);
    return await response.value();
  }

  /**
   * Retrieves a specific artifact captured during QA Copilot training
   * Get training artifact
   */
  async getTrainingArtifactRaw(
    requestParameters: GetTrainingArtifactRequest
  ): Promise<runtime.ApiResponse<TrainingArtifact>> {
    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        "id",
        "Required parameter requestParameters.id was null or undefined when calling getTrainingArtifact."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/trainingartifacts/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(requestParameters.id))
      ),
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      TrainingArtifactFromJSON(jsonValue)
    );
  }

  /**
   * Retrieves a specific artifact captured during QA Copilot training
   * Get training artifact
   */
  async getTrainingArtifact(
    requestParameters: GetTrainingArtifactRequest
  ): Promise<TrainingArtifact> {
    const response = await this.getTrainingArtifactRaw(requestParameters);
    return await response.value();
  }

  /**
   * Retrieves metadata for a specific training session
   * Get training session
   */
  async getTrainingSessionRaw(
    requestParameters: GetTrainingSessionRequest
  ): Promise<runtime.ApiResponse<TrainingSession>> {
    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        "id",
        "Required parameter requestParameters.id was null or undefined when calling getTrainingSession."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/trainingsessions/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(requestParameters.id))
      ),
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      TrainingSessionFromJSON(jsonValue)
    );
  }

  /**
   * Retrieves metadata for a specific training session
   * Get training session
   */
  async getTrainingSession(
    requestParameters: GetTrainingSessionRequest
  ): Promise<TrainingSession> {
    const response = await this.getTrainingSessionRaw(requestParameters);
    return await response.value();
  }

  /**
   * Issues an Ably TokenRequest scoped to the training-session.{id} channel so that the frontend can subscribe to live updates for this training run.
   * Get Ably token for training session
   */
  async getTrainingSessionTokenRaw(
    requestParameters: GetTrainingSessionTokenRequest
  ): Promise<runtime.ApiResponse<TrainingSessionToken>> {
    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        "id",
        "Required parameter requestParameters.id was null or undefined when calling getTrainingSessionToken."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/trainingsessions/{id}/token`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(requestParameters.id))
      ),
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      TrainingSessionTokenFromJSON(jsonValue)
    );
  }

  /**
   * Issues an Ably TokenRequest scoped to the training-session.{id} channel so that the frontend can subscribe to live updates for this training run.
   * Get Ably token for training session
   */
  async getTrainingSessionToken(
    requestParameters: GetTrainingSessionTokenRequest
  ): Promise<TrainingSessionToken> {
    const response = await this.getTrainingSessionTokenRaw(requestParameters);
    return await response.value();
  }

  /**
   * List messages for a QA Copilot thread
   */
  async listQaCopilotMessagesRaw(
    requestParameters: ListQaCopilotMessagesRequest
  ): Promise<runtime.ApiResponse<Array<QacConversationMessage>>> {
    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        "id",
        "Required parameter requestParameters.id was null or undefined when calling listQaCopilotMessages."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.limit !== undefined) {
      queryParameters["_limit"] = requestParameters.limit;
    }

    if (requestParameters.start !== undefined) {
      queryParameters["_start"] = requestParameters.start;
    }

    if (requestParameters.sort !== undefined) {
      queryParameters["_sort"] = requestParameters.sort;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/qa_copilot/threads/{id}/messages`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(requestParameters.id))
      ),
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(QacConversationMessageFromJSON)
    );
  }

  /**
   * List messages for a QA Copilot thread
   */
  async listQaCopilotMessages(
    requestParameters: ListQaCopilotMessagesRequest
  ): Promise<Array<QacConversationMessage>> {
    const response = await this.listQaCopilotMessagesRaw(requestParameters);
    return await response.value();
  }

  /**
   * List QA Copilot conversation threads
   */
  async listQaCopilotThreadsRaw(
    requestParameters: ListQaCopilotThreadsRequest
  ): Promise<runtime.ApiResponse<Array<QacConversationThread>>> {
    if (
      requestParameters.company === null ||
      requestParameters.company === undefined
    ) {
      throw new runtime.RequiredError(
        "company",
        "Required parameter requestParameters.company was null or undefined when calling listQaCopilotThreads."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.company !== undefined) {
      queryParameters["company"] = requestParameters.company;
    }

    if (requestParameters.project !== undefined) {
      queryParameters["project"] = requestParameters.project;
    }

    if (requestParameters.status !== undefined) {
      queryParameters["status"] = requestParameters.status;
    }

    if (requestParameters.sourceUrl !== undefined) {
      queryParameters["source_url"] = requestParameters.sourceUrl;
    }

    if (requestParameters.search !== undefined) {
      queryParameters["search"] = requestParameters.search;
    }

    if (requestParameters.limit !== undefined) {
      queryParameters["_limit"] = requestParameters.limit;
    }

    if (requestParameters.start !== undefined) {
      queryParameters["_start"] = requestParameters.start;
    }

    if (requestParameters.sort !== undefined) {
      queryParameters["_sort"] = requestParameters.sort;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/qa_copilot/threads`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(QacConversationThreadFromJSON)
    );
  }

  /**
   * List QA Copilot conversation threads
   */
  async listQaCopilotThreads(
    requestParameters: ListQaCopilotThreadsRequest
  ): Promise<Array<QacConversationThread>> {
    const response = await this.listQaCopilotThreadsRaw(requestParameters);
    return await response.value();
  }

  /**
   * Returns artifacts captured for QA Copilot training sessions
   * List training artifacts
   */
  async listTrainingArtifactsRaw(
    requestParameters: ListTrainingArtifactsRequest
  ): Promise<runtime.ApiResponse<Array<TrainingArtifact>>> {
    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.trainingSession !== undefined) {
      queryParameters["training_session"] = requestParameters.trainingSession;
    }

    if (requestParameters.status !== undefined) {
      queryParameters["status"] = requestParameters.status;
    }

    if (requestParameters.stepIndex !== undefined) {
      queryParameters["step_index"] = requestParameters.stepIndex;
    }

    if (requestParameters.limit !== undefined) {
      queryParameters["_limit"] = requestParameters.limit;
    }

    if (requestParameters.start !== undefined) {
      queryParameters["_start"] = requestParameters.start;
    }

    if (requestParameters.sort !== undefined) {
      queryParameters["_sort"] = requestParameters.sort;
    }

    if (requestParameters.filter !== undefined) {
      queryParameters["_filter"] = requestParameters.filter;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/trainingartifacts`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(TrainingArtifactFromJSON)
    );
  }

  /**
   * Returns artifacts captured for QA Copilot training sessions
   * List training artifacts
   */
  async listTrainingArtifacts(
    requestParameters: ListTrainingArtifactsRequest
  ): Promise<Array<TrainingArtifact>> {
    const response = await this.listTrainingArtifactsRaw(requestParameters);
    return await response.value();
  }

  /**
   * Returns QA Copilot training sessions filtered by test case or revision
   * List training sessions
   */
  async listTrainingSessionsRaw(
    requestParameters: ListTrainingSessionsRequest
  ): Promise<runtime.ApiResponse<Array<TrainingSession>>> {
    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.testcase !== undefined) {
      queryParameters["testcase"] = requestParameters.testcase;
    }

    if (requestParameters.testcaserevision !== undefined) {
      queryParameters["testcaserevision"] = requestParameters.testcaserevision;
    }

    if (requestParameters.status !== undefined) {
      queryParameters["status"] = requestParameters.status;
    }

    if (requestParameters.result !== undefined) {
      queryParameters["result"] = requestParameters.result;
    }

    if (requestParameters.limit !== undefined) {
      queryParameters["_limit"] = requestParameters.limit;
    }

    if (requestParameters.start !== undefined) {
      queryParameters["_start"] = requestParameters.start;
    }

    if (requestParameters.sort !== undefined) {
      queryParameters["_sort"] = requestParameters.sort;
    }

    if (requestParameters.filter !== undefined) {
      queryParameters["_filter"] = requestParameters.filter;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/trainingsessions`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(TrainingSessionFromJSON)
    );
  }

  /**
   * Returns QA Copilot training sessions filtered by test case or revision
   * List training sessions
   */
  async listTrainingSessions(
    requestParameters: ListTrainingSessionsRequest
  ): Promise<Array<TrainingSession>> {
    const response = await this.listTrainingSessionsRaw(requestParameters);
    return await response.value();
  }

  /**
   * Updates an existing QA Copilot artifact entry
   * Update training artifact
   */
  async updateTrainingArtifactRaw(
    requestParameters: UpdateTrainingArtifactRequest
  ): Promise<runtime.ApiResponse<TrainingArtifact>> {
    if (
      requestParameters.trainingArtifactPayload === null ||
      requestParameters.trainingArtifactPayload === undefined
    ) {
      throw new runtime.RequiredError(
        "trainingArtifactPayload",
        "Required parameter requestParameters.trainingArtifactPayload was null or undefined when calling updateTrainingArtifact."
      );
    }

    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        "id",
        "Required parameter requestParameters.id was null or undefined when calling updateTrainingArtifact."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/trainingartifacts/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(requestParameters.id))
      ),
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: TrainingArtifactPayloadToJSON(
        requestParameters.trainingArtifactPayload
      ),
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      TrainingArtifactFromJSON(jsonValue)
    );
  }

  /**
   * Updates an existing QA Copilot artifact entry
   * Update training artifact
   */
  async updateTrainingArtifact(
    requestParameters: UpdateTrainingArtifactRequest
  ): Promise<TrainingArtifact> {
    const response = await this.updateTrainingArtifactRaw(requestParameters);
    return await response.value();
  }

  /**
   * Updates QA Copilot training metadata
   * Update training session
   */
  async updateTrainingSessionRaw(
    requestParameters: UpdateTrainingSessionRequest
  ): Promise<runtime.ApiResponse<TrainingSession>> {
    if (
      requestParameters.trainingSessionPayload === null ||
      requestParameters.trainingSessionPayload === undefined
    ) {
      throw new runtime.RequiredError(
        "trainingSessionPayload",
        "Required parameter requestParameters.trainingSessionPayload was null or undefined when calling updateTrainingSession."
      );
    }

    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        "id",
        "Required parameter requestParameters.id was null or undefined when calling updateTrainingSession."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/trainingsessions/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(requestParameters.id))
      ),
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: TrainingSessionPayloadToJSON(
        requestParameters.trainingSessionPayload
      ),
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      TrainingSessionFromJSON(jsonValue)
    );
  }

  /**
   * Updates QA Copilot training metadata
   * Update training session
   */
  async updateTrainingSession(
    requestParameters: UpdateTrainingSessionRequest
  ): Promise<TrainingSession> {
    const response = await this.updateTrainingSessionRaw(requestParameters);
    return await response.value();
  }
}

/**
 * @export
 * @enum {string}
 */
export enum CountTrainingArtifactsStatusEnum {
  Pass = "pass",
  Fail = "fail",
}
/**
 * @export
 * @enum {string}
 */
export enum CountTrainingSessionsStatusEnum {
  Ready = "ready",
  Inprogress = "inprogress",
}
/**
 * @export
 * @enum {string}
 */
export enum CountTrainingSessionsResultEnum {
  Passed = "passed",
  Failed = "failed",
}
/**
 * @export
 * @enum {string}
 */
export enum ListQaCopilotThreadsStatusEnum {
  Open = "open",
  Closed = "closed",
  Archived = "archived",
}
/**
 * @export
 * @enum {string}
 */
export enum ListTrainingArtifactsStatusEnum {
  Pass = "pass",
  Fail = "fail",
}
/**
 * @export
 * @enum {string}
 */
export enum ListTrainingSessionsStatusEnum {
  Queued = "queued",
  Inprogress = "inprogress",
  Ready = "ready",
  Failed = "failed",
}
/**
 * @export
 * @enum {string}
 */
export enum ListTrainingSessionsResultEnum {
  Passed = "passed",
  Failed = "failed",
}
